export default "__VITE_ASSET__CkTJ4v1h__"